<template>
  <div class="identity">
    <BaseHeaderBar
      title="Informasi Identitas"
      :showCustomerService="false"
      :showBackButton="true"
    />
    <div class="content">
      <div>
        <template v-if="ktpImg">
          <img class="ktp-img" :src="ktpImg" />
          <div class="close" @click="deleteKtp">
            <img src="@/assets/img/close.png" />
          </div>
        </template>
        <van-uploader
          v-else
          :after-read="afterKtpRead"
          :preview-image="false"
          capture="camera"
        >
          <img class="upload-icon" src="@/assets/img/identity.png" />
          <p>KTP</p>
        </van-uploader>
      </div>
      <div>
        <template v-if="userImg">
          <img class="user-img" :src="userImg" />
          <div class="close" @click="deleteUser">
            <img src="@/assets/img/close.png" />
          </div>
        </template>
        <div class="fileUpload" @click="afterUserRead" v-else>
          <input
            v-if="!isUseLatestLogic() && ktpImg"
            type="file"
            accept="image/*"
            capture="user"
            ref="videoFile"
            @change="afterUserRead"
            class="file_input"
          />
          <img class="recognition-icon" src="@/assets/img/recognition.png" />
          <p>Fitur Pengenalan Wajah</p>
        </div>
      </div>
    </div>
    <button type="button" class="confirm-btn" @click="onSubmit">Kirim</button>
    <van-overlay :show="loadingShow">
      <van-loading v-if="!flag" color="#FB4F5D" vertical>{{
        loadingText
      }}</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader, Toast, Loading, Overlay } from 'vant'
import axios from 'axios'
import Compressor from 'compressorjs'
import request from '@/utils/request'
import webviewBack from '@/mixins/webviewBack'
import { getDurationSeconds } from '@/utils/formTracking'
import EXIF from 'exif-js'
Vue.use(Uploader)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Overlay)

function randomString (len = 32) {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

const ktpLoadingText = 'Proses Unggah'

export default {
  name: 'Identity',
  mixins: [webviewBack],
  data () {
    return {
      imgSrc: '',
      ktpImg: '',
      loadingShow: false,
      loadingText: '',
      userImg: '',
      flag: false,
      KtpImgSource: null,
      userImgSource: null,
      uploadTracking: this.createUploadTracking(),
      shouldResetTracking: false
    }
  },
  created () {
    this.getIdentify()
    this.uploadPromise = this.getUploadParams()
  },

  methods: {
    createUploadTracking () {
      return {
        pageEnterTime: Date.now(),
        ktp: {
          startedAt: 0,
          duration: 0,
          num: 0
        },
        selfie: {
          startedAt: 0,
          duration: 0,
          num: 0
        }
      }
    },
    resetUploadTracking () {
      this.uploadTracking = this.createUploadTracking()
    },
    startUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      tracking.startedAt = Date.now()
    },
    finishUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      const startedAt = tracking.startedAt || Date.now()
      tracking.duration += getDurationSeconds(startedAt)
      tracking.num += 1
      tracking.startedAt = 0
    },
    cancelUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      tracking.startedAt = 0
    },
    getUploadTrackingData () {
      return {
        ktp_duration: this.uploadTracking.ktp.duration,
        ktp_num: this.uploadTracking.ktp.num,
        selfie_duration: this.uploadTracking.selfie.duration,
        selfie_num: this.uploadTracking.selfie.num,
        pagestay_duration: getDurationSeconds(this.uploadTracking.pageEnterTime)
      }
    },
    getIdentify () {
      request.post('iddrentityInfoPage')
        .then(res => {
          this.userImg = res.usdrerLiving_imgurl
        })
    },
    isSupportUserMedia () {
      return navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia
    },
    getUploadParams () {
      return request.post('updrloadImgToken')
    },
    uploadImg (file) {
      return new Promise((resolve, reject) => {
        this.uploadPromise.then(res => {
          const key = 'web/' + Date.now() + randomString(10) + '-' + file.name
          const formData = new FormData()
          formData.append('OSSAccessKeyId', 'LTAI5tD9wrLfvn8sEpRLfpbw')
          formData.append('key', key)
          formData.append('policy', res.podrlicy)
          formData.append('signature', res.sidrgnature)
          formData.append('file', file)
          formData.append('success_action_status', 200)
          axios.post('https://inphotos.oss-ap-southeast-1.aliyuncs.com', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(() => resolve(`https://inphotos.oss-ap-southeast-1.aliyuncs.com/${key}`))
            .catch(error => {
              Toast('Unggal Gagal')
              reject(error)
            })
        }).catch(error => {
          Toast('Unggal Gagal')
          reject(error)
        })
      })
    },
    afterKtpRead (file) {
      if (!file || !file.file) return
      this.startUploadTracking('ktp')
      this.loadingText = ktpLoadingText
      this.loadingShow = true
      this.compressImage(file.file, result => {
        this.uploadImg(result).then(async res => {
          this.ktpImg = res
          this.finishUploadTracking('ktp')
          const isFromCamera = await this.isImageFromCamera(file.file)
          this.KtpImgSource = isFromCamera ? 1 : 2
        }).catch(() => {
          this.cancelUploadTracking('ktp')
        }).finally(() => {
          this.loadingShow = false
        })
      })
    },
    compressImage (file, success) {
      let quality = 1
      const size = file.size
      const baseQuality = 1024 * 1024
      if (size < baseQuality) { // 小于1M
        quality = 0.8
      } else if (size < 5 * baseQuality) { // 小于5M
        quality = 0.4
      } else if (size < 10 * baseQuality) { // 小于10M
        quality = 0.1
      } else { // 大于10M
        quality = 0
      }
      console.log('size', size, quality)
      new Compressor(file, {
        quality,
        success
      })
    },
    deleteKtp () {
      this.ktpImg = ''
    },
    deleteUser () {
      this.userImg = ''
    },
    afterUserRead () {
      if (!this.ktpImg) {
        Toast('Silakan foto KTP')
        return false
      }
      if (this.isUseLatestLogic()) {
        this.startUploadTracking('selfie')
        this.$router.push({
          path: '/userRead'
        })
        return
      }
      // 获取到input标签的上传的文件对象
      const files = this.$refs.videoFile && this.$refs.videoFile.files[0]
      if (!files) return
      this.startUploadTracking('selfie')
      // 通过FileReader构造函数创建一个新的FileReader对象
      const reader = new FileReader()
      // 通过新创建的FileReader对象获取input元素上传的files文件对象，并使用readAsDataURL()方法读取
      reader.readAsDataURL(files)
      // 这是一个异步操作，当读取完成后，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
      reader.onload = () => {
        this.compressImage(files, result => {
          this.uploadImg(result).then(async res => {
            this.userImg = res
            this.finishUploadTracking('selfie')
            Toast('Berhasil submit')
            const isFromCamera = await this.isImageFromCamera(files)
            this.userImgSource = isFromCamera ? 1 : 2
          }).catch(() => {
            this.cancelUploadTracking('selfie')
          })
        })
      }
    },
    isImageFromCamera (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          const img = new Image()
          img.onload = () => {
            EXIF.getData(img, () => {
              const orientation = EXIF.getTag(img, 'Orientation')
              resolve(orientation !== undefined) // EXIF的Orientation标签存在，则可能是相机拍摄
            })
          }
          img.src = event.target.result
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    validate () {
      if (!this.ktpImg) {
        Toast('Silakan foto KTP')
        return false
      }
      if (!this.userImg) {
        Toast('Silakan foto selfie')
        return false
      }
      return true
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.loadingShow = true
      this.flag = true
      const trackingData = this.getUploadTrackingData()
      const postData = {
        phdrotoList: JSON.stringify([{
          phdrotoUrl: this.ktpImg,
          phdrotoType: '1',
          uploadType: navigator.platform,
          imgSource: this.KtpImgSource,
          uuid: sessionStorage.getItem('enhedensdige')
        }, {
          phdrotoUrl: this.userImg,
          phdrotoType: '2',
          uploadType: navigator.platform,
          imgSource: this.userImgSource,
          uuid: sessionStorage.getItem('enhedensdige')
        }])
      }
      request.post('iddrentityInfosubmit', postData)
        .then(() => {
          return request.post('identityInfoTracking', trackingData).catch(() => false)
        })
        .then(() => {
          Toast('Pembaruan infomasi identitas berhasil')
          this.$router.back()
        })
        .catch(res => {
          if (res && res.code === 502) {
            this.deleteKtp()
          }
        })
        .finally(() => {
          this.flag = false
          this.loadingShow = false
        })
    }
  },
  activated () {
    if (this.shouldResetTracking) {
      this.resetUploadTracking()
      this.shouldResetTracking = false
    }
  },
  beforeRouteEnter (to, from, next) {
    const { userReadUrl, isFromCamera } = to.query
    if (userReadUrl) {
      next(vm => {
        // 在这里，`vm` 是组件的实例，你可 以访问它的数据和方法
        vm.userImg = userReadUrl
        vm.userImgSource = isFromCamera
        vm.finishUploadTracking('selfie')
      })
      return
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.shouldResetTracking = to.path !== '/userRead'
    next()
  }
}
</script>

<style scoped lang="less">
.identity {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  padding-left: 40px;
  padding-right: 40px;

  & > div {
    display: flex;
    justify-content: center;
    position: relative;
    height: 472px;
    margin-top: 24px;
    border-radius: 12px;
    box-shadow: inset 0 1px 0 0 rgba(253, 248, 241, 0.32);
    background-color: #fff;
    overflow: auto;
    .fileUpload {
      position: relative;
      .file_input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
    .upload-icon,
    .recognition-icon {
      width: 590px;
      margin: 36px auto 0;
    }

    .upload-icon {
      height: 390px;
    }

    .recognition-icon {
      height: 364px;
    }

    p {
      line-height: 30px;
      font-size: 28px;
      font-weight: 500;
      color: #a6a8aa;
      text-align: center;
    }

    /deep/ .van-loading {
      position: absolute;
    }
  }

  .ktp-img,
  .user-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);

  img {
    width: 40px;
    height: 40px;
  }
}

.confirm-btn {
  .submit-bg-btn;
  margin-top: 80px;
  margin-bottom: 60px;
}
</style>
